import styled from 'styled-components';

interface WrapperProps {
  rounded: 'xs' | 'sm' | 'md' | 'lg' | 'xl';
  space?: number;
}

enum RoundedMaps {
  'xs' = '2px',
  'sm' = '4px',
  'md' = '8px',
  'lg' = '12px',
  'xl' = '16px',
}

const ButtonGroupWrapper = styled.div<WrapperProps>(
  ({ rounded, space = 8 }) => `
    button.spaced {
      margin-right: ${space}px;
    }

    button.spaced:last-child {
      margin-right: 0px;
    }

    button.no-spaced {
      border-radius: 0px;
    }

    button.no-spaced:first-child {
      border-top-left-radius: ${RoundedMaps[rounded]};
      border-bottom-left-radius: ${RoundedMaps[rounded]};
    }
    button.no-spaced:last-child {
      border-top-right-radius: ${RoundedMaps[rounded]};
      border-bottom-right-radius: ${RoundedMaps[rounded]};
    }
  `
);

export { ButtonGroupWrapper };
